import { render, staticRenderFns } from "./WorkspaceSettingsPaymentMethod.vue?vue&type=template&id=62bdefa1&scoped=true"
import script from "./WorkspaceSettingsPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceSettingsPaymentMethod.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WorkspaceSettingsPaymentMethod.vue?vue&type=style&index=0&id=62bdefa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bdefa1",
  null
  
)

export default component.exports